import { useSincroPolling } from 'core/hooks/useSincroPolling';
import React, { useEffect, useState } from 'react';
import SyncProgress from './SyncProgress';

function SyncProgressContainer() {
  const { syncStatus, isActive } = useSincroPolling();
  const [showComponent, setShowComponent] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [localExiting, setLocalExiting] = useState(false);

  useEffect(() => {
    if (isActive) {
      // Retrasar la aparición del componente por 2 segundos para dar tiempo a que se carguen las traducciones
      const timer = setTimeout(() => {
        setShowComponent(true);
        setIsExiting(false);
        setLocalExiting(false);
      }, 2000);

      return () => {
        clearTimeout(timer);
      };
    } else {
      // Solo iniciar animación de salida si no está en salida local
      if (!localExiting) {
        setIsExiting(true);

        // Mantener el componente en el DOM durante la animación (300ms)
        const exitTimer = setTimeout(() => {
          setShowComponent(false);
          setIsExiting(false);
        }, 300);

        return () => {
          clearTimeout(exitTimer);
        };
      }
    }
  }, [isActive, localExiting]);

  // Función para manejar el cierre local
  const handleLocalExit = () => {
    setLocalExiting(true);

    // Mantener el componente en el DOM durante la animación local
    setTimeout(() => {
      setShowComponent(false);
      setLocalExiting(false);
    }, 300);
  };

  return showComponent ? <SyncProgress syncStatus={syncStatus} isExiting={isExiting || localExiting} onLocalExit={handleLocalExit} /> : null;
}

export default SyncProgressContainer;
